
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Interaction/DragDropList.html",
      function () {
        return require("private-next-pages/Interaction/DragDropList.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Interaction/DragDropList.html"])
      });
    }
  